import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/i18n/I18nProvider";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import Shop from "@/components/Shop";
import Footer from "@/components/Footer";
import LoginModal from "@/components/LoginModal";
import AccountPage from "@/pages/AccountPage";
import AdminPage from "@/pages/AdminPage";

const Landing = () => {
    const [loginOpen, setLoginOpen] = useState(false);
    return (
        <div className="min-h-screen bg-[#FAFAF8]" data-testid="landing-page">
            <Header onLogin={() => setLoginOpen(true)} />
            <Shop />
            <Footer />
            <LoginModal
                open={loginOpen}
                onClose={() => setLoginOpen(false)}
            />
        </div>
    );
};

function App() {
    return (
        <div className="App">
            <I18nProvider>
                <AuthProvider>
                    <CartProvider>
                        <Toaster
                            position="bottom-right"
                            richColors
                            toastOptions={{
                                style: {
                                    fontFamily: "Manrope, sans-serif",
                                    borderRadius: "12px",
                                    pointerEvents: "auto",
                                },
                            }}
                            // Toast container itself doesn't intercept clicks; only the
                            // individual toast surface above does. Prevents toasts from
                            // blocking the cart drawer's checkout button on quick add+open.
                            style={{ pointerEvents: "none" }}
                            duration={2200}
                        />
                        <BrowserRouter>
                            <Routes>
                                <Route path="/" element={<Landing />} />
                                <Route path="/account" element={<AccountPage />} />
                                <Route path="/admin" element={<AdminPage />} />
                            </Routes>
                        </BrowserRouter>
                    </CartProvider>
                </AuthProvider>
            </I18nProvider>
        </div>
    );
}

export default App;
